import React, { useEffect } from "react";
import { CheckCircle, CreditCard, Calendar } from "lucide-react";
import "../../styles/PaymentSuccess.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { formatDateWithAmPm } from "../../Style";
import CustomButton from "../../component/ui/FormFields/Button";
import { useDispatch, useSelector } from "react-redux";
import {
  BOOKINGS,
  DASHBOARD,
  LOGIN,
} from "../../component/common/Routes/AppRoutes";
import {
  VENDOR_BOOKINGS,
  VENDOR_DASHBOARD,
} from "../../component/common/Routes/VendorRoutes";
import {
  CUSTOMER_BOOKINGS,
  CUSTOMER_DASHBOARD,
} from "../../component/common/Routes/CustomerRoutes";
import { resetBookingDetails } from "../../redux/Bookings/BookingAction";
import localStorage from "redux-persist/es/storage";

const PaymentSuccess = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const orderDetails = location.state?.orderData || "";
  const { user } = useSelector((state) => state.auth);

  const paymentAmount = parseFloat(orderDetails?.payment_logs?.order?.total);
  const pnr = orderDetails?.pnr_number;
  const currency = "INR";
  const email = user?.email || orderDetails?.customer_email;

  useEffect(() => {
    dispatch(resetBookingDetails());
  }, [dispatch]);

  useEffect(() => {
    if (!pnr) return;

    const totalPassengers =
      Number(orderDetails?.total_passengers) ||
      Number(orderDetails?.number_of_adults || 0) +
        Number(orderDetails?.number_of_child || 0) +
        Number(orderDetails?.number_of_infant || 0);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "booking_success",
      transaction_id: pnr,
      transaction_amount: paymentAmount,
      transaction_currency: currency,
      customer_email: email,
      total_passengers: totalPassengers,
      adults: Number(orderDetails?.number_of_adults || 0),
      children: Number(orderDetails?.number_of_child || 0),
      infants: Number(orderDetails?.number_of_infant || 0),

      enhanced_conversion_data: {
        email: email,
      },
    });

    console.log("📌 Data Layer Sent:", {
      pnr,
      paymentAmount,
      currency,
      email,
      totalPassengers,
    });
  }, [pnr, paymentAmount, currency, email, orderDetails]);

  return (
    <div className="payment-success-container">
      <div className="payment-card">
        {/* UI Same as Before */}
        <div className="success-header">
          <div className="icon-container">
            <CheckCircle size={56} strokeWidth={2.5} />
          </div>
          <h1>Payment Successful!</h1>
        </div>

        <div className="content">
          <p className="success-message">
            Thank you for your Booking. Your payment has been processed
            successfully.
          </p>

          {/* Transaction Details */}
          <div className="transaction-details">
            <h2>Transaction Details</h2>

            <div className="detail-row">
              <div className="detail-label">
                <CreditCard size={18} />
                <span>PNR NUMBER</span>
              </div>
              <span className="detail-value amount">{pnr}</span>
            </div>

            <div className="detail-row">
              <div className="detail-label">
                <CreditCard size={18} />
                <span>Amount</span>
              </div>
              <span className="detail-value amount">₹{paymentAmount}</span>
            </div>

            <div className="detail-row">
              <div className="detail-label">
                <Calendar size={18} />
                <span>Date</span>
              </div>
              <span className="detail-value">
                {formatDateWithAmPm(orderDetails?.created_at)}
              </span>
            </div>
          </div>

          {user ? (
            <div className="action-buttons">
              <CustomButton
                variant="contained"
                className="cancel-button"
                type="button"
                text="View Bookings"
                onClick={() => {
                  let bookingsRoute;

                  if (user.role === "Admin" || user.role === "Staff") {
                    bookingsRoute = BOOKINGS;
                  } else if (user.role === "Vendor") {
                    bookingsRoute = VENDOR_BOOKINGS;
                  } else if (user.role === "Customer") {
                    bookingsRoute = CUSTOMER_BOOKINGS;
                  }
                  navigate(bookingsRoute);
                }}

                // onClick={() => navigate()}
              />
              <CustomButton
                variant="contained"
                className="success-button"
                type="button"
                text={"Return to Dashboard"}
                onClick={() => {
                  let dashboardRoute;

                  if (user.role === "Admin" || user.role === "Staff") {
                    dashboardRoute = DASHBOARD;
                  } else if (user.role === "Vendor") {
                    dashboardRoute = VENDOR_DASHBOARD;
                  } else if (user.role === "Customer") {
                    dashboardRoute = CUSTOMER_DASHBOARD;
                  }
                  navigate(dashboardRoute);
                }}
              />
            </div>
          ) : (
            <button
              className="cancel-button"
              onClick={() => {
                localStorage.removeItem("instantToken");
                localStorage.removeItem("accessToken");
                localStorage.removeItem("refreshToken");

                navigate(LOGIN);
              }}
            >
              <span>Close</span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
